module.exports = "https://beta.voredev.ru/assets/index/question-0ca7f8a225e572a994fda0768645600c.svg";